// Shared admin helpers + constants
// Extracted from AdminDashboard.jsx to keep that file lean.

export const API = process.env.REACT_APP_BACKEND_URL;

export function getAuthHeaders() {
  // NOTE: This codebase stores the JWT in localStorage for simplicity. For higher security,
  // switch to httpOnly cookies with SameSite=Strict + CSRF tokens. Backlog item P2 — requires
  // backend session middleware and is a multi-file refactor across auth/login/admin endpoints.
  const token = localStorage.getItem('admin_token');
  return { Authorization: `Bearer ${token}` };
}

export function isHotLead(createdAt) {
  const submitted = new Date(createdAt);
  const now = new Date();
  return (now - submitted) < 24 * 60 * 60 * 1000;
}

export function timeAgo(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

export function getLastActivity(lead) {
  const times = [lead.created_at];
  for (const n of (lead.notes || [])) { if (n.created_at) times.push(n.created_at); }
  for (const t of (lead.tasks || [])) { if (t.created_at) times.push(t.created_at); }
  for (const s of (lead.sms_history || [])) { if (s.timestamp) times.push(s.timestamp); }
  for (const h of (lead.stage_history || [])) { if (h.changed_at) times.push(h.changed_at); }
  if (lead.first_contact_at) times.push(lead.first_contact_at);
  if (lead.follow_up?.last_email_sent) times.push(lead.follow_up.last_email_sent);
  return times.sort().pop();
}

export function isStale(lead) {
  return (
    (!lead.status || lead.status === 'new') &&
    !lead.first_contact_at &&
    (Date.now() - new Date(lead.created_at).getTime()) > 48 * 60 * 60 * 1000
  );
}

export function hasUnreadSms(lead) {
  return (lead.sms_history || []).some((s) => s.direction === 'inbound');
}

export const STATUS_CONFIG = {
  new: { label: 'New', color: 'bg-slate-500/15 text-slate-300' },
  contacted: { label: 'Contacted', color: 'bg-blue-500/15 text-blue-400' },
  meeting_scheduled: { label: 'Meeting', color: 'bg-violet-500/15 text-violet-400' },
  proposal_sent: { label: 'Proposal', color: 'bg-amber-500/15 text-amber-400' },
  won: { label: 'Won', color: 'bg-emerald-500/15 text-emerald-400' },
  lost: { label: 'Lost', color: 'bg-red-500/15 text-red-400' },
};

export const PIPELINE_ORDER = ['new', 'contacted', 'meeting_scheduled', 'proposal_sent', 'won', 'lost'];
